const findWorkerEvent = (events, type) => {
  if (!Array.isArray(events)) return 'None';

  const eventFound = events.find(event => event.value === type);
  
  if (eventFound !== undefined) {
    return eventFound.name;
  }

  return 'None';
}

export default findWorkerEvent;
